import { render, staticRenderFns } from "./MyMove.vue?vue&type=template&id=6a6ea676&scoped=true"
import script from "./MyMove.vue?vue&type=script&lang=js"
export * from "./MyMove.vue?vue&type=script&lang=js"
import style0 from "./MyMove.vue?vue&type=style&index=0&id=6a6ea676&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6ea676",
  null
  
)

export default component.exports